import { graphql } from "@opensea/graphql"
import { MintModuleFragment } from "@/components/collection/drops/components/MintModule/MintModule.fragment"
import { ContentBlockModuleFragment } from "./components/ContentBlockModule/ContentBlockModule.fragment"
import { FaqModuleFragment } from "./components/FaqModule/FaqModule.fragment"
import { NarrativeModuleFragment } from "./components/NarrativeModule/NarrativeModule.fragment"
import { TeamModuleFragment } from "./components/TeamModule/TeamModule.fragment"

export const CollectionOverviewFragment = graphql(
  `
    fragment CollectionOverview on Collection {
      ...MintModule
      category
      slug
      overview {
        modules {
          __typename
          ... on CollectionNarrativeModule {
            ...NarrativeModule
          }
          ... on CollectionFAQModule {
            ...FaqModule
          }
          ... on CollectionTeamModule {
            ...TeamModule
          }
          ... on CollectionContentBlockModule {
            ...ContentBlockModule
          }
        }
      }
    }
  `,
  [
    NarrativeModuleFragment,
    FaqModuleFragment,
    TeamModuleFragment,
    ContentBlockModuleFragment,
    MintModuleFragment,
  ],
)
